"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1135],{

/***/ 1135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16543);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73040);
/* harmony import */ var _helper_date__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41937);





var BoltIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            d: "M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z",
            clipRule: "evenodd"
        })
    });
};
var CheckIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            d: "M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z",
            clipRule: "evenodd"
        })
    });
};
var XIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            d: "M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z",
            clipRule: "evenodd"
        })
    });
};
var SonDakika = function(param) {
    var page = param.page, onSelect = param.onSelect;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .m)(), detailLastMinuteTitle = ref.detailLastMinuteTitle, detailLastMinuteText = ref.detailLastMinuteText, selectTheseDates = ref.selectTheseDates, dateSelected = ref.dateSelected, nights = ref.nights, clearSelection = ref.clearSelection;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedId = ref1[0], setSelectedId = ref1[1];
    var list = Array.isArray(page === null || page === void 0 ? void 0 : page.sonDakika) ? page.sonDakika : [];
    // Fiyat gizlenen (gavel) villalarda fırsat kutusu da gösterilmez
    if (!list.length || (page === null || page === void 0 ? void 0 : page.gavel) != "0") return null;
    var villaUrl = "/" + String(page.url || "").replace(/^\//, "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "px-3 sm:px-[1.3rem] lg:px-0 mt-4 lg:mt-7",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "overflow-hidden bg-white border-2 lg:border-[3px] border-[#F7C9D6] rounded",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center gap-2 px-4 py-3 text-white lg:px-7 bg-gradient-to-r from-[#E01252] to-[#FF7A45]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BoltIcon, {
                            className: "w-5 h-5 shrink-0 animate-pulse"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-base font-bold lg:text-lg",
                            children: detailLastMinuteTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "hidden ml-auto text-xs font-semibold opacity-90 lg:block",
                            children: detailLastMinuteText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "flex flex-col divide-y divide-[#F7E3E9]",
                    children: list.map(function(item) {
                        var start = (0,_helper_date__WEBPACK_IMPORTED_MODULE_4__/* .toIsoDate */ .v)(item.tarih1);
                        var end = (0,_helper_date__WEBPACK_IMPORTED_MODULE_4__/* .toIsoDate */ .v)(item.tarih2);
                        var href = start && end ? villaUrl + "?start=" + start + "&end=" + end : villaUrl;
                        var isSelected = selectedId == item.id;
                        // Tarihler formda seçilir, sayfa yenilenmez.
                        // href sadece JS çalışmadığında / yeni sekmede açıldığında devreye girer.
                        var SelectDates = function(e) {
                            if (!onSelect || !start || !end) return;
                            e.preventDefault();
                            setSelectedId(item.id);
                            onSelect(start, end);
                        };
                        var ClearDates = function(e) {
                            e.preventDefault();
                            setSelectedId(null);
                            if (onSelect) onSelect(null, null);
                        };
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "flex flex-nowrap items-center gap-2 px-4 py-3 lg:gap-5 lg:px-7 lg:py-4 transition-colors " + (isSelected ? "bg-[#FFF7F9]" : ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-2 min-w-0 shrink lg:gap-5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col items-center justify-center w-12 h-12 lg:w-14 lg:h-14 shrink-0 rounded-md bg-[#FFF1F4] text-[#E01252] leading-none",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    className: "text-lg lg:text-xl",
                                                    children: item.gun
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "mt-0.5 text-xxs font-bold uppercase tracking-1 lg:mt-1",
                                                    children: item.ay
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col min-w-0 leading-tight",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                                    className: "text-sm text-brand-black truncate lg:text-lg",
                                                    children: [
                                                        item.gun1,
                                                        " - ",
                                                        item.gun2
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "text-xs font-semibold opacity-50 lg:text-13",
                                                    children: [
                                                        item.gece,
                                                        " ",
                                                        nights
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col items-end gap-1 ml-auto shrink-0 lg:flex-row lg:items-center lg:gap-5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-base font-bold lg:text-xl text-[#E01252]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                value: parseInt(item.fiyat),
                                                Symbol: item.Symbol || page.Symbol
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    href: href,
                                                    onClick: SelectDates,
                                                    title: page.baslik,
                                                    className: "flex items-center gap-1.5 px-3 py-2 text-xs font-bold rounded-md transition-colors whitespace-nowrap lg:px-4 lg:py-2.5 lg:text-sm " + (isSelected ? "bg-[#FFE0E9] text-[#E01252]" : "bg-[#E01252] text-white hover:bg-[#c40f48]"),
                                                    children: [
                                                        isSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CheckIcon, {
                                                            className: "w-4 h-4"
                                                        }),
                                                        isSelected ? dateSelected : selectTheseDates
                                                    ]
                                                }),
                                                isSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    type: "button",
                                                    onClick: ClearDates,
                                                    title: clearSelection,
                                                    className: "flex items-center justify-center w-8 h-8 lg:w-9 lg:h-9 rounded-md border-2 border-[#F7C9D6] bg-white text-[#E01252] hover:bg-[#E01252] hover:border-[#E01252] hover:text-white transition-all duration-200 shrink-0 shadow-sm",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(XIcon, {
                                                        className: "w-4 h-4"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, item.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SonDakika);


/***/ })

}]);